import BlockSettingsSchema from '@plone/volto/components/manage/Blocks/Block/Schema';
import type { BlocksConfigData } from '@plone/types';

import EmbedTrekksoftEdit from 'iovisit-reggioemiliawelcome/components/Blocks/EmbedTrekksoft/Edit';
import EmbedTrekksoftView from 'iovisit-reggioemiliawelcome/components/Blocks/EmbedTrekksoft/View';
import embedTrekksoftSchema from 'iovisit-reggioemiliawelcome/components/Blocks/EmbedTrekksoft/schema';
import { type embedTrekksoftConfig } from 'iovisit-reggioemiliawelcome/components/Blocks/EmbedTrekksoft/schema';
import CodeSVG from '@plone/volto/icons/code.svg';
import zoomSVG from '@plone/volto/icons/zoom.svg';

import Ross1000StruttureView from 'iovisit-reggioemiliawelcome/components/Blocks/Ross1000Strutture/View';
import Ross1000StruttureEdit from 'iovisit-reggioemiliawelcome/components/Blocks/Ross1000Strutture/Edit';
import ross1000StruttureSchema from 'iovisit-reggioemiliawelcome/components/Blocks/Ross1000Strutture/schema';
import type { ross1000struttureConfig } from 'iovisit-reggioemiliawelcome/components/Blocks/Ross1000Strutture/schema';

declare module '@plone/types' {
  interface BlocksConfigData {
    embedtrekksoft: embedTrekksoftConfig;
    ross1000strutture: ross1000struttureConfig;
  }
}

export type ReggioEmiliaWelcomeBlocksConfig = Pick<
  BlocksConfigData,
  'embedtrekksoft' | 'ross1000strutture'
>;

const defaultBlocksConfig = {
  restricted: false,
  mostUsed: false,
  security: {
    addPermission: [],
    view: [],
  },
  sidebarTab: 1,
  schema: BlockSettingsSchema,
} as const;

export const ReggioEmiliaWelcomeBlocks: ReggioEmiliaWelcomeBlocksConfig = {
  embedtrekksoft: {
    ...defaultBlocksConfig,
    id: 'embedtrekksoft',
    title: 'Embed trekksoft',
    icon: CodeSVG,
    group: 'common',
    view: EmbedTrekksoftView,
    edit: EmbedTrekksoftEdit,
    blockSchema: embedTrekksoftSchema,
    restricted: ({ contentType, properties }) => {
      // @ts-ignore
      return contentType !== 'Document' && !!!properties?.booking_embed_html;
    },
  },
  ross1000strutture: {
    ...defaultBlocksConfig,
    id: 'ross1000strutture',
    title: 'Ricerca strutture Ross1000',
    icon: zoomSVG,
    group: 'search',
    edit: Ross1000StruttureEdit,
    view: Ross1000StruttureView,
    blockSchema: ross1000StruttureSchema,
  },
};
